// Deep links for X and LinkedIn on mobile
document.addEventListener("DOMContentLoaded", function () {
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouchDevice) return;

  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute("href");

    var xMatch = href.match(/(?:twitter\.com|x\.com)\/([A-Za-z0-9_]+)/);
    if (xMatch) {
      e.preventDefault();
      var handle = xMatch[1];
      var deepLink = "twitter://user?screen_name=" + handle;
      var didNavigate = false;
      window.location.href = deepLink;
      setTimeout(function () {
        if (!didNavigate) window.open(href, "_blank", "noopener,noreferrer");
      }, 500);
      window.addEventListener("blur", function onBlur() {
        didNavigate = true;
        window.removeEventListener("blur", onBlur);
      });
      return;
    }

    var liMatch = href.match(/linkedin\.com\/(in|company)\/([A-Za-z0-9_-]+)/);
    if (liMatch) {
      e.preventDefault();
      var type = liMatch[1];
      var slug = liMatch[2];
      var liDeep = type === "company"
        ? "linkedin://company/" + slug
        : "linkedin://in/" + slug;
      var didNav = false;
      window.location.href = liDeep;
      setTimeout(function () {
        if (!didNav) window.open(href, "_blank", "noopener,noreferrer");
      }, 500);
      window.addEventListener("blur", function onBlur2() {
        didNav = true;
        window.removeEventListener("blur", onBlur2);
      });
    }
  });
});

// Mobile menu toggle
document.addEventListener("DOMContentLoaded", function () {
  const hamburgerButton = document.querySelector(".hamburger-menu-button");
  const closeButton = document.querySelector(".close-menu-button");
  const mobileMenu = document.querySelector(".mobile-menu-opened");
  const desktopMenu = document.querySelector(".desktop-menu-closed");

  if (mobileMenu) {
    mobileMenu.style.display = "none";
  }

  if (hamburgerButton && mobileMenu && desktopMenu) {
    hamburgerButton.addEventListener("click", () => {
      mobileMenu.style.display = "flex";
      desktopMenu.style.display = "none";
    });
  }

  if (closeButton && mobileMenu && desktopMenu) {
    closeButton.addEventListener("click", () => {
      desktopMenu.style.display = "flex";
      mobileMenu.style.display = "none";
    });
  }
});

// Tax deductible toggle for donation form
document.addEventListener("DOMContentLoaded", function () {
  const taxYes = document.getElementById("tax-deductible-yes");
  const taxNo = document.getElementById("tax-deductible-no");
  const nameLabel = document.getElementById("name-label");
  const emailLabel = document.getElementById("email-label");

  if (!taxYes || !taxNo || !nameLabel || !emailLabel) return;

  const nameInput = document.getElementById("name");
  const emailInput = document.getElementById("email");

  function updateLabels(isRequired) {
    const nameHint = nameLabel.querySelector(".label-hint");
    const emailHint = emailLabel.querySelector(".label-hint");
    if (nameHint) nameHint.textContent = isRequired ? "(Required)" : "(Optional)";
    if (emailHint) emailHint.textContent = isRequired ? "(Required)" : "(Optional)";
    if (nameInput) nameInput.required = isRequired;
    if (emailInput) emailInput.required = isRequired;
  }

  taxYes.addEventListener("change", function () {
    if (this.checked) updateLabels(true);
  });

  taxNo.addEventListener("change", function () {
    if (this.checked) updateLabels(false);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="/#"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      if (window.location.pathname === "/" || window.location.pathname === "/index.html") {
        e.preventDefault();
        var id = this.getAttribute("href").substring(2);
        var target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }

        var mobileMenu = document.querySelector(".mobile-menu-opened");
        var desktopMenu = document.querySelector(".desktop-menu-closed");
        if (mobileMenu && mobileMenu.style.display !== "none") {
          mobileMenu.style.display = "none";
          if (desktopMenu) desktopMenu.style.display = "flex";
        }
      }
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    var href = link.getAttribute("href");
    if (href === "#" || href.length <= 1) return;
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var id = href.substring(1);
      var target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }

      var mobileMenu = document.querySelector(".mobile-menu-opened");
      var desktopMenu = document.querySelector(".desktop-menu-closed");
      if (mobileMenu && mobileMenu.style.display !== "none") {
        mobileMenu.style.display = "none";
        if (desktopMenu) desktopMenu.style.display = "flex";
      }
    });
  });
});

// Header scroll observer
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-content");
  const headerContainer = document.querySelector(".header-container");
  if (!header) return;

  const sentinel = document.createElement("div");
  sentinel.style.position = "relative";
  sentinel.style.height = "1px";
  sentinel.style.width = "100%";
  header.parentNode.parentNode.insertBefore(sentinel, header.parentNode);

  let observer = null;

  function createScrollObserver(el, className) {
    return new IntersectionObserver(
      (entries) => {
        el.classList.toggle(className, !entries[0].isIntersecting);
      },
      { threshold: 0 },
    );
  }

  function initObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    const isDesktop = window.innerWidth > 1100;
    if (isDesktop) {
      observer = createScrollObserver(header, "scrolled");
      headerContainer.classList.remove("glass-effect-mobile");
      observer.observe(sentinel);
    } else {
      headerContainer.classList.add("glass-effect-mobile");
      header.classList.remove("scrolled");
    }
  }

  initObserver();

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initObserver, 150);
  });
});
